import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid, StatusChip } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable, statusToChip } from "@/components/kcc/DataTable";

export default function Warehouse360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/warehouse/overview").then(({ data }) => setData(data)); }, []);
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Warehouse360" title="Materials, Spares & Consumables" description="Central materials catalogue with critical spares, rotables, min-max policies, fraud indicators and consumption forecasting." />
            <KpiGrid kpis={data?.kpis || []} accent="cobalt" cols={4} />
            <Panel title="Stock Ledger" accent="cobalt">
                <DataTable
                    columns={[
                        { key: "sku", label: "SKU" },
                        { key: "name", label: "Item" },
                        { key: "category", label: "Category" },
                        { key: "location", label: "Bin" },
                        { key: "stock_qty", label: "Stock", render: (r) => `${r.stock_qty.toLocaleString()} ${r.unit}` },
                        { key: "reorder_point", label: "Reorder", render: (r) => r.reorder_point.toLocaleString() },
                        { key: "value_usd", label: "Value", render: (r) => `$${Math.round(r.value_usd).toLocaleString()}` },
                        { key: "status", label: "Status", render: (r) => <StatusChip status={statusToChip(r.status)}>{r.status}</StatusChip> },
                    ]}
                    rows={data?.items || []}
                    testid="warehouse-table"
                />
            </Panel>
        </div>
    );
}
